// This is a modified version of repository.js in common folder.
// At the time of writing carshare and flexigp use different authentication methods

import Axios from 'axios';
import { endRumSession, trackApiCall } from '../helpers/rum';

// this is temporary, will be removed when we have a proper authentication
function redirectUrl() {
  const [base] = window.location.hostname.split('.');
  const urls = {
    localhost: '/login',
    secure: 'https://secure.flexigo.com?lang=tr',
    portal: 'https://portal.flexigo.com?lang=en',
    secure3: 'https://secure3.vektorteknoloji.com/flexigo/',
    timezone: 'https://timezone.flexigo.com',
  };

  return urls[base];
}

// When the session was established via /auto-login (webview embedding), an expired
// session re-enters that route so SSO can re-authenticate silently instead of
// showing the login page. Returns null for normal users (no context key).
function autoLoginReentryUrl() {
  try {
    const context = JSON.parse(localStorage.getItem('flexigoAutoLoginContext'));
    if (!context?.email) return null;
    const currentPath = window.location.hash.slice(1);
    const params = new URLSearchParams({ email: context.email, target: currentPath });
    if (context.lang) params.set('lang', context.lang);
    return `#/auto-login?${params.toString()}`;
  } catch (error) {
    return null;
  }
}

export default class {
  constructor(options) {
    this.createInstance(options);
  }

  createInstance(options = {}) {
    const headers = {
      EHM: 'Exception',
    };
    let defaultOptions = {
      responseType: 'json',
      timeout: 60000,
      headers,
    };

    defaultOptions = Object.assign(defaultOptions, options);
    const instance = Axios.create(defaultOptions);

    instance.interceptors.response.use(
      (response) => {
        if (response?.data?.error) {
          trackApiCall(response.config, false, response.status);
          console.error(response.data.error, response.data.message);
          return Promise.reject(response.data);
        }
        trackApiCall(response.config, true, response.status);
        return response;
      },
      (error) => {
        // Because of this specific API server doesnt return right HTTTP codes.
        // So it shouldnt enter here most of the time.
        console.log(error);
        console.log(error.response);
        trackApiCall(error.config, false, error.response?.status ?? error.code);
        if (error.response) {
          // AutoLogin drives verify/check-domain itself and handles failures; redirecting
          // here would cause a loop
          if (window.location.hash.startsWith('#/auto-login')) {
            return Promise.reject(error);
          }
          if (
            error.response.status === 400 &&
            error.request.responseURL.includes('oauth/web/session/verify') &&
            !error.request.responseURL.includes('verifyPin')
          ) {
            // const redirectUrl = error.response.headers.location;
            // console.log('Redirect to:', redirectUrl);
            endRumSession();
            window.location.href = autoLoginReentryUrl() ?? redirectUrl();
          }
          if (error.response.status === 403) {
            console.log('Unauthorized');
            endRumSession();
            window.location.href = autoLoginReentryUrl() ?? redirectUrl();
          }
        }
        return Promise.reject(error);
      },
    );

    this.instance = instance;
    return instance;
  }

  async get(url, params = null, rawData = false, config = {}) {
    const response = await this.instance.get(url, { params, ...config });
    return rawData ? response : response.data;
  }

  async post(url, payload, config = undefined) {
    const response = await this.instance.post(url, payload, config);
    return response.data;
  }

  async put(url, payload) {
    const response = await this.instance.put(url, payload);
    return response.data;
  }

  async delete(url, payload = undefined) {
    // delete method in axios 0.20 is broken, this is a workaround
    const response = await this.instance.request({
      url,
      data: payload,
      method: 'delete',
    });
    return response.data;
  }
}
